<template lang="html">
    <div class="create-container">
        <v-toolbar class="modal-header">
            <div class="app-logo">
                <img src="../../../assets/img/logo_s_pink.svg" />
            </div>
            <v-btn flat @click.native="onClose">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title >Symbole</v-toolbar-title>
        </v-toolbar>

        <v-toolbar flat class="create-toolbar">
            <avatar class="create-avatar" :item="user" size="5rem"></avatar>
            <v-layout column justify-space-around align-content-space-around>
                <v-flex> <b>{{user.first_name}} {{user.last_name}}</b></v-flex>
                <div class="date">
                    <pre class="date-line">  </pre>Le {{moment().format('DD/MM/YYYY')}}
                </div>
            </v-layout>
            <v-btn round small flat :color="'primary'" @click="cancel()">Annuler</v-btn>
            <v-btn round depressed small :color="'primary'" @click="saveElement()" :loading="loading">Enregistrer</v-btn>
        </v-toolbar>

        <div class="center-content" :class="[nb_column == 2 ? 'doubleCol' : '']">
            <v-form v-model="valid_title" >
                <v-layout row class="title-row">
                    <v-flex :xs12="isCol(1)" :sm12="isCol(2)" :md6="isCol(2)" class="edit-title">
                        <v-text-field
                        name='titre1_text_field'
                        label='Titre'
                        hint='Titre de votre commentaire'
                        v-model="symbol.title"
                        :rules="rules.title"
                        :error="error"
                        :persistent-hint="error"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex v-if="isCol(2)" sm12 md6 class="edit-title">
                        <v-text-field
                        name='titre2_text_field'
                        label='Titre 2'
                        v-model="symbol.title_2"
                        hint='Deuxième titre'
                        :error="error_2"
                        :rules="rules.title_2"
                        :persistent-hint="error_2"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-form v-model="valid_message">
                <v-layout row>
                    <v-flex :xs12="isCol(1)" :sm12="isCol(2)" :md6="isCol(2)" class="edit-message">
                        <v-text-field
                        name='message_text_field'
                        label='Message'
                        hint='Contenu du message'
                        v-model="symbol.message"
                        multi-line
                        :error="error"
                        :persistent-hint="error"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex v-if="isCol(2)" md6 sm12 class="edit-message">
                        <v-text-field
                        name='message_text_field2'
                        label='Message 2'
                        v-model="symbol.message_2"
                        multi-line
                        hint='Contenu du deuxième message'
                        :error="error_2"
                        :persistent-hint="error_2"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>

            <!-- #region --images -->
            <v-flex xs12>
                <v-layout wrap>
                    <v-layout :xs12="isCol(1)" :sm12="isCol(2)" :md6="isCol(2)">
                        <v-flex v-for="(file,index) in symbol.files_1" :key="file.id">
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <v-icon class="hover-alpha">mode_edit</v-icon>
                                        <img :src="file.path"/>
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile class="li">
                                       <label :for="'file1-'+index">Modifier l'image</label>
                                       <input class="input-img" :id="'file1-'+index" style="display:none" type="file" @change="(event)=>{onFileChange(event,1,index)}"/>
                                   </v-list-tile>
                                   <v-list-tile @click="$refs.deletefile.open('symbols',file,'files_1')" class="li">
                                       <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                        <v-flex v-if="symbol.files_1.length < 2">
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <img :src="addImgPath()" class="add-img" />
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile>
                                       <label :for="'file1-input'">Ajouter une image</label>
                                       <input class="input-img" id="file1-input" style="display:none" type="file" @change="(event)=>{onFileChange(event,1)}"/>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>

                    <v-layout v-if="isCol(2)" sm12 md6>
                        <v-flex v-for="(file,index) in symbol.files_2" :key="file.id">
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <v-icon class="hover-alpha">mode_edit</v-icon>
                                        <img :src="file.path"/>
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile>
                                       <label :for="'file2-'+index">Modifier l'image</label>
                                       <input class="input-img" :id="'file2-'+index" style="display:none" type="file" @change="(event)=>{onFileChange(event,2,index)}"/>
                                   </v-list-tile>
                                   <v-list-tile @click="$refs.deletefile.open('symbols',file,'files_2')">
                                       <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>

                        <v-flex v-if="isCol(2) && symbol.files_2.length < 2">
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <img :src="addImgPath()" class="add-img" />
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile>
                                       <label :for="'file2-input'">Ajouter une image</label>
                                       <input class="input-img" id="file2-input" style="display:none" type="file" @change="(event)=>{onFileChange(event,2)}"/>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>

            <!-- #endregion -->

        </div>

        <div class="column-display-choice">
            <div class="col-choice-title">
                Affichage :
            </div>
            <div class="column-display-buttons">
                <div>
                    <div @click="setColumnNumber(1)" class="image-and-overlay-left">
                        <img src="../../../assets/img/full.svg" class="col-chose-image"/>
                        <div v-if="nb_column===1" class="col-choice-overlay"></div>
                    </div>
                </div>
                <div>
                    <div @click="setColumnNumber(2)" class="image-and-overlay-right">
                        <img src="../../../assets/img/split.svg" class="col-chose-image"/>
                        <div v-if="nb_column===2" class="col-choice-overlay"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- #region -- confirm remove col modal -->
        <v-dialog v-model="removeCol" max-width="750px">
            <v-card>
                <v-card-title class="warning">
                    <h2>
                        <v-icon dark class="mr-2">warning</v-icon>
                        <span class="white--text">Attention</span>
                    </h2>
                    <v-spacer></v-spacer>
                    <v-btn small icon @click="removeCol = false">
                        <v-icon dark>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Voulez vous vraiment supprimer la deuxième colonne ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round small outline color="warning" @click.native="removeCol = false;">Annuler</v-btn>
                    <v-btn round depressed small color="warning" @click.native="deleteCol()">Valider</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- #endregion -->
        <delete-linked-file ref="deletefile" @deleted="function (entity_id,item_id) { deleteFile(entity_id,item_id) }"></delete-linked-file>
    </div>
</template>

<script>
import Avatar   from '../../../components/avatar/Avatar.vue'
import moment from 'moment'
import DeleteLinkedFile   from '../../../components/files/DeleteLinkedFiles.vue'

export default {
    components: {
        Avatar,
        DeleteLinkedFile,
    },
    data() {
        return {
            moment,
            nb_column:1,
            symbol : {
                title: '',
                title_2: null,
                message: '',
                message_2:null,
                files_1:[],
                files_2:[],
                files: [],
            },
            files: [],
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            valid_button: false,
            cancel_button: false,
            valid_title: false,
            valid_message: false,
            error_2: false,
            error: false,
            removeCol: false,
            display: true,
            loading: false,
            rules: {
                title: [
                    function(v){
                        if(v) {
                            if(v.length >= 150) {
                                return 'Le titre ne dois pas contenir plus de 150 caractères'
                            } else {
                                return true
                            }
                        } else {
                            return 'Titre obligatoire'
                        }
                    }
                ],
                title_2: [
                    function(v){
                        if(v){
                            if(v.length >= 150) {
                                return 'Le titre ne dois pas contenir plus de 150 caractères'
                            } else {
                                return true
                            }
                        } else {
                            return true
                        }
                    }
                ]
            }
        }
    },
    computed:{
        user : function (){
            return this.$store.state.auth.user;
        }
    },
    methods: {
        deleteFile(entity,item){
            let index = this.symbol[entity].findIndex((el)=>el.path === item)
            this.symbol[entity].splice(index,1)
        },
        onFileChange(evt,fileArray,fileIndex,col){
            let array = this.symbol['files_' + fileArray];
            if (fileIndex >= 0){
                array[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                array[fileIndex].file = evt.target.files[0];
                array[fileIndex].toUpdate = true;
            } else {
                fileIndex = array.length;
                array.push({
                    path: URL.createObjectURL(evt.target.files[0]),
                    file: evt.target.files[0],
                    toUpdate: true
                })
            }
        },
        deleteCol(){
            this.symbol.message_2 = null
            this.symbol.title_2 = null
            this.removeCol = false
            this.nb_column = 1
        },
        addImgPath() {
            return require('../../../assets/img/addimg.svg')
        },
        setColumnNumber(nb_column) {
            if(this.symbol.title_2 != '' && this.symbol.title_2 != null){
                if(this.nb_column == 2) {
                    this.removeCol = true
                } else {
                    this.nb_column = nb_column
                    this.error_2 = false
                }
            } else if(this.symbol.message_2 != '' && this.symbol.message_2 != null){
                if(this.nb_column == 2) {
                    this.removeCol = true
                } else {
                    this.nb_column = nb_column
                    this.error_2 = false
                }
            } else {
                this.nb_column = nb_column
                this.error_2 = false
            }
        },
        isCol(number) {
            if(this.nb_column === number) {
                return true;
            }
            else {
                return false;
            }
        },
        cancel:function (){
            this.$eventHub.$emit('close-modal');
        },
        onClose(){
            this.$eventHub.$emit('close-modal')
        },
        saveElement : function (){
            if(this.valid_title && this.valid_message){
                if(this.nb_column == 2 && this.symbol.title_2 == null && this.symbol.message_2 == null) {
                    this.error_2 = true
                } else {
                    this.loading = true
                    let savePhotoRec =(symboleId,arrayId,index,callback)=>{
                        if (arrayId < 3) {
                            if (index < this.symbol['files_' + arrayId].length){
                                let file =this.symbol['files_' + arrayId][index];
                                let data = new FormData();
                                    data.append('file',file.file),
                                    data.append('location','area-' + arrayId);

                                this.axios.post(`/api/symbols/${symboleId}/file`,data)
                                    .then(response => {
                                        savePhotoRec(symboleId,arrayId,++index,callback);
                                    });

                            } else {
                                 savePhotoRec(symboleId,++arrayId,0,callback);
                            }
                        } else {
                            callback();
                        }
                    };
                    this.axios.post('/api/symbols',{
                            label: this.symbol.title,
                            title: this.symbol.title,
                            title_2: this.symbol.title_2,
                            message: this.symbol.message,
                            message_2:this.symbol.message_2,
                            user_id : this.user.id
                        })
                        .then(response => {
                            savePhotoRec(response.data.id,1,0,()=>{
                                this.$eventHub.$emit('close-modal');
                                this.$eventHub.$emit('reload-list');
                                this.loading = false
                            });
                        });
                }
            } else {
                this.error = true
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/variables'
    .files {
        label {
            font-size: 1.6rem
            height: 100%
            width: 100%
            display: flex
            align-items: center
            cursor: pointer
        }
    }
    .modal-header {
        z-index: 2
        height: $header-hight
        background: white
        box-shadow: 0 0 33px 0 #EBEFF5 !important
    }
    .create-container {
        margin:0 10px 0 10px
        .create-toolbar {
            margin-left: 65px
            margin-right: 125px
            margin-top: 56px !important
            background: white
            width: calc(100% - 190px)
            .create-avatar{
                margin: 10px
            }
            .date {
                display:flex
                font-size:1.2rem
                .date-line {
                    margin:8px
                    width:15px;
                    background: #000
                    height:1px;
                }
            }
        }
        .column-display-choice {
            padding: 0 5rem
            position: absolute
            bottom: 1rem
            background: white
            font-size: 2rem
            width: 100%
            height: 70px !important
            align-items: center
            cursor: pointer
            .column-display-buttons{
                display: inline-flex
                position: relative
                top: 0
                left: 0
                .image-and-overlay-left {
                    position: relative
                    bottom: 25px
                    left: 0
                }
                .image-and-overlay-right {
                    position: relative
                    bottom: 25px
                    left: 80px
                }
                .col-chose-image {
                    position: absolute
                    top: 0
                    left: 0
                    width:70px
                    height: 35px
                    margin: 10px
                    margin-top: 5px
                    padding: 0
                }
                .col-choice-overlay {
                    position: absolute
                    top: 0
                    left: 0
                    width:70px
                    height 35px
                    background: rgba(252,225,255,0.5);
                    box-shadow: 0 8px 18px 0 rgba(253,232,255,1);
                    border-radius: 10px;
                    margin: 10px
                    margin-top: 5px
                    z-index:10
                }
            }
        }
        .center-content {
            input {
                display: none;
            }

            position: relative;
            margin-top: 60px
            margin-left: 100px
            margin-right: 100px
            width: calc(100% - 200px)
            .title-row{
                max-height: 80px !important
            }
            .edit-title {
                margin-bottom: 0  !important
                margin-top: 0  !important
                margin: 2rem !important
                border-color: black !important
                border-width: 10px !important
                border-radius: 8px !important
                font-size: 50px !important
                max-height: 80px !important
            }

            .comment-title {
                padding-bottom: 1rem
                padding-top: 1rem
                font-size: 5rem !important
            }

            .edit-message {
                margin-bottom: 0
                margin: 2rem !important
                margin-top: 0 !important
                border-color: black !important
                border-width: 10px !important
                border-radius: 8px !important
                font-size: 50px !important
            }

            .comment-image {
                margin-top: 25px
                height: 150px
                width: 150px
                margin-bottom: 10px
                background-color: rgba(0,0,0,0.68)
                cursor: pointer
                display: block
                img {
                    width:100%
                    height:100%
                    object-fit: contain
                    background-color: #FFF
                    &.add-img {
                        padding: 40px !important
                        background-color: rgba(0, 0, 0, 0.5)
                    }
                }
                .hover-alpha {
                    height: 100%
                    width: 100%
                    position: absolute
                    margin-bottom: 35px
                    &:not(hover) {
                        background-color: rgba(0, 0, 0, 0);
                        color: rgba(0, 0, 0, 0);
                    }
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.5);
                        color: white;
                    }
                }
            }

            .comment-no-image {
                height: 150px
                width: 150px
                margin-bottom: 35px
            }

            .on-left {
                padding-right: 1rem
            }
            .on-right {
                padding-left: 1rem
            }
            @media screen and (max-width: 900px){
                &.doubleCol {
                    form{
                        .layout {
                            flex-direction: column
                            .edit-title {
                                &:last-of-type{
                                    position: relative
                                    top: 40rem
                                }
                            }
                            .edit-message {
                                &:last-of-type{
                                    position: relative
                                    top: 33rem
                                }
                            }
                        }
                        &:last-of-type{
                            height: 19rem
                        }
                    }
                    .flex {
                        .layout {
                            flex-direction: column
                            div.layout.sm12{
                                &:last-of-type{
                                    position: relative
                                    top: 33rem
                                }
                            }
                        }
                    }
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/views/symbols/list/Create.vue